export const config = {
    pixelId: 't2_3p1vryn4',
}
